import { createContext, useContext, useEffect } from "react";
import { DEFAULT_BRAND } from "../lib/brands";
import { configureLive } from "../lib/live";

const BrandContext = createContext(DEFAULT_BRAND);

export const useBrand = () => useContext(BrandContext);

const setLink = (rel, href) => {
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.rel = rel;
    document.head.appendChild(el);
  }
  if (el.getAttribute("href") !== href) el.setAttribute("href", href);
};

export const BrandProvider = ({ brand, title, children }) => {
  configureLive(brand.storageKey, brand.id);
  useEffect(() => {
    document.title = `${brand.name} | ${title}`;
    document.documentElement.dataset.theme = brand.theme;
    document.querySelector('meta[name="theme-color"]')?.setAttribute("content", brand.themeColor);
    document.querySelector('meta[name="apple-mobile-web-app-title"]')?.setAttribute("content", brand.id === "suporte" ? "Atendimento" : brand.name);
    setLink("icon", brand.favicon);
    setLink("apple-touch-icon", brand.touchIcon);
    setLink("manifest", brand.manifest);
  }, [brand, title]);
  return <BrandContext.Provider value={brand}>{children}</BrandContext.Provider>;
};
